// extracted by mini-css-extract-plugin
export default {"Navigation_mobile_list":"NavigationMobile_Navigation_mobile_list__TQ1I1"};